import { OrderLineInvoice } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { IconButton } from '@ravago/shared/radiance/components/button/components/IconButton/IconButton';
import { Divider } from '@ravago/shared/radiance/components/divider/components/Divider/Divider';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useFormatter, useTranslations } from '@ravago/shared/translations/client';

interface Props {
   documents: Array<OrderLineInvoice>;
   showInvoiceDocuments: boolean;
   onDownload: (document: OrderLineInvoice) => void;
   onViewDocument: (document: OrderLineInvoice) => void;
}

export const InvoiceDocuments = ({ documents, showInvoiceDocuments, onDownload, onViewDocument }: Props) => {
   const translate = useTranslations();
   const format = useFormatter();

   if (!showInvoiceDocuments) {
      return (
         <Typography variant="body" component="span">
            {translate('permissions.no-view-invoice-documents-permission')}
         </Typography>
      );
   }

   if (!documents || documents.length === 0) {
      return (
         <Typography variant="body" component="span">
            {translate('page-consumer.order-line-flyout.no-documents-available')}
         </Typography>
      );
   }

   return documents.map((document, index) => (
      // eslint-disable-next-line @eslint-react/no-array-index-key
      <Box key={index} direction="column" gap="sm" width="100%">
         <Box gap="xl">
            <Box direction="column" gap="none" width="50%">
               <Typography variant="body" component="span" color="strong">
                  {translate('page-consumer.order-line-flyout.invoice-type')}
               </Typography>
               <Typography variant="body" component="span">
                  {document.type}
               </Typography>
            </Box>
            <Box direction="column" gap="none" width="50%">
               <Typography variant="body" component="span" color="subtle">
                  {translate('page-consumer.order-line-flyout.invoice-number')}
               </Typography>
               <Typography variant="body" component="span">
                  {document.number}
               </Typography>
            </Box>
         </Box>
         <Box justify="between">
            <Box direction="column" gap="none">
               <Typography variant="body" component="span" color="subtle">
                  {translate('page-consumer.order-line-flyout.invoice-date')}
               </Typography>
               <Typography variant="body" component="span">
                  {format.dateTime(document.createdOn) || '-'}
               </Typography>
            </Box>
            <Box gap="2xs">
               <IconButton icon="download" ariaLabel="Download Invoice" onClick={() => onDownload(document)} />
               <IconButton icon="eye" ariaLabel="View Invoice" onClick={() => onViewDocument(document)} />
            </Box>
         </Box>
         {index < documents.length - 1 && <Divider />}
      </Box>
   ));
};
